export const data = [
  {
    image: 'norbertImage',
    quote:
      'We enjoy the input from each individual team member about the technology, content, and design. This feedback gives us the chance to get in touch with new ideas that you can’t see if you have been involved in the same company for years.',
    author: '<strong>Norbert Bauman</strong>, sonnen',
  },
  {
    image: 'neilImage',
    quote:
      'The team proactively developed a viable plan to deliver and implement the final product. During phase one, we needed to build a basic platform and mobile apps by our radio channel launch date. They managed minute aspects of design and development.',
    author: '<strong>Neil DeSouza</strong>, Sabco Media, Virgin Radio Oman',
  },
  {
    image: 'alexImage',
    quote:
      'From a team perspective, we liked their style and design but what’s been awesome is the process that they go through. There is an unbelievable amount of transparency and organization to the point that in every instance they could save time, they have.',
    author: '<strong>Alex</strong>, Polco',
  },
];
